import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

import ServiceDetail from "./serviceDetail";
import { styles } from "./styles";
import BoxHeader from "../imageHeader";
class ServiceOwner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
    };
  }
  render() {
    const { classes, service = {} } = this.props;
    console.log(service)
    return (
      <>
        <div className={classes.boxImage}>
          <BoxHeader service={service} />
        </div>
        <ServiceDetail service={service} />
      </>
    );
  }
}

ServiceOwner.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  service: state.service.service,
});

const mapDispatch = (dispatch) => ({
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(ServiceOwner)
  )
);
